export default{
    name: 'cardSkClub',
    props: {
        onLink: Function,
        onActivate: Function,
        isLinked: Boolean,
        isJoined: Boolean,
        CardNumber: String,
        linking: Boolean,
        activating:Boolean,
        activationLink:String,
        moreInfoLink:String,
        disabled:Boolean,
        genericMessage:String,
    },
    data(){
        return {
            showConfirmReplaceCard: false,
            thisCardNumber: null,
            showCardAdder: false,
            joining:false,
        }
    },

    methods: {

        // showConfirmReplaceCard() {
        //     this.showConfirmReplaceCard = true
        // },

    },

    watch:{
        linking(nw,old){
            if(nw == false && this.isLinked && this.thisCardNumber == this.CardNumber){
                this.showCardAdder = false;
            }

            if(nw == false) this.joining = false;
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/profile/card/cardMixin.js